//
import axios from '../axios';
import config from '../../config';
const { leaderURL } = config;
export default {
  // 获取球员列表
  getWoamnScout(params) {
    return axios(leaderURL + `/woman/scout/list`, {
      method: 'get',
      params,
    });
  },
};
